// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3awCD","rootSmall":"AddTileButton_rootSmall__3M-uQ"};